module.exports = __webpack_public_path__ + "static/img/icon-wj.d0289dc0.png";